import { useQuery } from 'react-query';

import { useHeaderDataQueryConfig } from '../atoms/HeaderDataProvider';

export interface IOrganizationBranding {
  readonly id: string;
  readonly cdnList: string[];
  readonly bannerLogoRelativeUrl: string;
  readonly backgroundColor: string;
  readonly backgroundImageRelativeUrl: string;
}

export function useGetOrganizationBranding(tenantId: string): {data: IOrganizationBranding | undefined; isLoading: boolean; isError: boolean} {
  const { acquireMSGraphToken, msGraphBaseUrl, reportApiSuccess, reportApiFailure } = useHeaderDataQueryConfig();
  const queryKey = ['orgBranding', tenantId];

  const { data, isLoading, isError } = useQuery({
    queryKey,
    cacheTime: 1000 * 60 * 60 * 24, // 24 hrs
    staleTime: 1000 * 60 * 60, // 1 hr
    queryFn: async () => {
      const token = await acquireMSGraphToken();
      return await fetch(`${msGraphBaseUrl}/v1.0/organization/${tenantId}/branding`, {
        headers: {
          Authorization: 'Bearer ' + token,
          'Accept-Language': '0'
        }
      })
        .then(async response => {
          if (response.status === 404) {
            return undefined;
          } else {
            return await response.json();
          }
        })
        .then((org: IOrganizationBranding | undefined) => org)
        .catch((error) => {
          reportApiFailure?.({ action: 'header/network-call/failure/get-organization-branding', message: error });
          throw error;
        });
    },
    onSuccess: () => {
      reportApiSuccess?.({ action: 'header/network-call/success/get-organization-branding' });
    }
  });

  return { data, isLoading, isError };
}
